import { smartDocParamType_Static } from './_base/index.js';
import { smartDocStaticParamType_Attribute } from './attribute/index.js';
import { smartDocStaticParamType_ChiefComplaint } from './chief-complaint/index.js';
import { smartDocStaticParamType_Factor } from './factor/index.js';
import { smartDocStaticParamType_Finding } from './finding/index.js';
import { smartDocStaticParamType_Tag } from './tag/index.js';
import { smartDocStaticParamType_Template } from './template/index.js';
import { smartDocStaticParamType_Orders } from './orders/index.js';
import { smartDocStaticParamType_ContextRule, smartDocStaticParamType_MDM, smartDocStaticParamType_PhysicianNotes } from './types.js';
import { smartDocStaticParamType_SmartMDM } from './smart-mdm/index.js';
import { smartDocStaticParamType_Time } from './time/index.js';
export const smartDocStaticParamTypeLabelMap = {
    [smartDocStaticParamType_Tag]: 'Tag',
    [smartDocStaticParamType_Attribute]: 'Attribute',
    [smartDocStaticParamType_ChiefComplaint]: 'Chief Complaint',
    [smartDocStaticParamType_Factor]: 'Factor',
    [smartDocStaticParamType_Finding]: 'Finding',
    [smartDocStaticParamType_Template]: 'Template',
    [smartDocStaticParamType_Orders]: 'Orders',
    [smartDocStaticParamType_PhysicianNotes]: 'Physician Notes',
    [smartDocStaticParamType_MDM]: 'MDM',
    [smartDocStaticParamType_ContextRule]: 'Context Rule',
    [smartDocStaticParamType_SmartMDM]: 'Smart MDM',
    [smartDocStaticParamType_Time]: 'Time',
};
export const smartDocStaticParam_PartialData = {
    [smartDocStaticParamType_Orders]: {
        orderSubtype: [],
        orderStatus: [],
        relatedResource: [],
    },
    [smartDocStaticParamType_MDM]: {
        protocolType: [],
        protocolConsiderationGroup: [],
        protocolStatus: [],
    },
    [smartDocStaticParamType_SmartMDM]: {
        protocolType: [],
        protocolConsiderationGroup: [],
        protocolStatus: [],
    }
};
export const defaultItem_SmartDocStaticParam = (key) => ({
    key,
    type: smartDocParamType_Static,
});
//# sourceMappingURL=consts.js.map